import React from "react";
import PropTypes from "prop-types";
import Datetime from "react-datetime";
import moment from "moment"

import axios from 'axios'
import { db } from "firebase/fbConfig.js"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from "@material-ui/core/FormControl";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Check from '@material-ui/icons/Check';

// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import styles from "assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx";
 
class Form extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      queryString: "",
      actionAssigned: false,
      assignedError: false,
      defaultLoaded: false,
      assigningAction: "",
      cardAnimaton: "cardHidden",
      shippingMode: '',
      pickUpServices: '',
      dropOffServices: '',
      services: '',
      items: []
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({
          queryString: this.props.queryString ? this.props.queryString : '',
          cardAnimaton: ""
        });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }
  
  handlePickUpDateChange = (pickUpDate) => {
    console.log(pickUpDate)
    if (pickUpDate) {
      this.setState(() => ({ pickUpDate }))
    }
  }

   handleDropOffDateChange = (dropOffDate) => {
    console.log(dropOffDate)
    if (dropOffDate) {
      this.setState(() => ({ dropOffDate }))
    }
  }

  // only make future selectable  
  valid = (current) => {
    return current.isAfter(Datetime.moment().subtract(1, 'day'));
  };

  handleSelectChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleTogglePickupServices(value) {
    const { pickUpServices } = this.state;
    const currentIndex = pickUpServices.indexOf(value);
    const newPickUpServices = [...pickUpServices];

    if (currentIndex === -1) {
      newPickUpServices.push(value);
    } else {
      newPickUpServices.splice(currentIndex, 1);
    }

    this.setState({
      pickUpServices: newPickUpServices
    });
  }

  handleToggleDropOffServices(value) {
    const { dropOffServices } = this.state;
    const currentIndex = dropOffServices.indexOf(value);
    const newDropOffServices = [...dropOffServices];

    if (currentIndex === -1) {
      newDropOffServices.push(value);
    } else {
      newDropOffServices.splice(currentIndex, 1);
    }

    this.setState({
      dropOffServices: newDropOffServices
    });
  }

  handleToggleServices(value) {
    const { services } = this.state;
    const currentIndex = services.indexOf(value);
    const newServices = [...services];

    if (currentIndex === -1) {
      newServices.push(value);
    } else {
      newServices.splice(currentIndex, 1);
    }

    this.setState({
      services: newServices
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const {
      queryString,
      title,
      description,
      dueDate,
      points
    } = this.state

    this.setState({
      assigningAction: "Starting assignment"
    })

    const { usersData } = this.props

    let UIDarray = []
    // Get any volUID where a user object value === queryString
    // and push to UIDarray
    usersData.forEach((user) => {
      const relKeys = ["volUID", "username", "email", "county"]
      if (queryString === "All") {
        UIDarray.push(user.volUID)
      } else {
        relKeys.forEach((key) => {
          if (user[key] === queryString) {
            UIDarray.push(user.volUID)
          }
        })
        let groups = user.groups.split(', ');
        groups.forEach((group) => {
          if (group === queryString) {
            UIDarray.push(user.volUID)
          }
        })
      }
    })    

    // Loop through UIDarray
    UIDarray.forEach((volUID) => {
      // create data object for firestore
      let dataObj = {
        status: "assigned",
        updatedAt: new Date(),
        title,
        description,
        points: parseInt(points),
        dueDate: dueDate.toDate(),
        volUID
      } 
      
      // Create new firestore action
      db.collection("TEST-actions-list")
        .doc().set(dataObj).then(() => {
          console.log(`assigned action to ${volUID}`)
          this.setState({
            assigningAction: `Assigning action to ${volUID}`
          })
          if (volUID === UIDarray[UIDarray.length - 1]) {
            this.setState({
              title: "",
              description: "",
              dueDate: moment(),
              days: "",
              points: "",
              assignedError: false,
              defaultLoaded: false,
              cardAnimaton: "cardHidden",
              actionAssigned: true
            })
          }
        }).catch((err) => {
          console.log(`Update TEST-actions-list with id: ${this.props.actionID} with error: ${err}`)
        })
    })
  }
  setDefaults = () => {
    this.setState({
      queryString: this.props.queryString ? this.props.queryString : '',
      defaultLoaded: true
    })
  }

  resetForm = () => {
    this.setState({
      title: "",
      description: "",
      dueDate: moment(),
      days: "",
      points: "",
      actionAssigned: false,
      assignedError: false,
      defaultLoaded: false,
      cardAnimaton: "cardHidden"
    })
  }

  resetRequest = () => {
    window.location.reload();
  }

  render() {
    const { classes, modalOpen } = this.props;

    const shippingModes = ['', 'LTL', 'TL']
    const locationTypes = ['Business', 'Construction Site', 'Convention Center or Tradeshow', 'Freight Carrier Terminal', 'Home Based Business', 'Mlitary Base', 'Mini-Storage / Self Storage Facility', 'Religious Institution', 'Residential / Home']
    const packagingTypes = ['Pallets: Standard (40" x 48")', 'Pallets (48" x 48")', 'Pallets (60" x 48")', 'Pallets (enter dimensions)', 'Boxed', 'Crated', 'Drums or Barrels']
    const freightClass = ['I dont know', '50', '55', '60', '65', '70', '77.5', '85', '92.5', '100', '110', '125', '150', '175', '200', '250', '300', '400', '500']

    // set queryString
    modalOpen && !this.state.defaultLoaded ? this.setDefaults() : null
    !modalOpen && this.state.defaultLoaded ? this.resetForm() : null

    // reset modal when closed
    if (!modalOpen && this.state.actionAssigned) { this.resetRequest() }
    console.log(this.state)
    return (
      <div>
        {this.state.actionAssigned ? (
          <GridContainer justify="center">
            <GridItem xs={11}>
              <h4 className={classes.textPrimary}>Action Assigned!</h4>
            </GridItem>
          </GridContainer>
        ) : (
            <div className={classes.formContainer}>
              <form onSubmit={this.handleSubmit}
              >
                <GridContainer justify="center">
                  <GridItem xs={11}>
                    {this.state.messageError ? <h5 className={classes.bodyText}>There Has Been An Error: {this.state.messageError}</h5> : null}
                <GridItem xs={6}>
                  </GridItem>
                  <FormControl
                  fullWidth
                  className={classes.selectFormControl}>
                  <InputLabel
                    htmlFor="shippingmode"
                    className={classes.selectLabel}>
                    SHIPPING MODE:
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={this.state.shippingMode}
                    onChange={this.handleSelectChange}
                    inputProps={{
                      id: 'shippingMode',
                      name: 'shippingMode'
                    }}
                  >
                    {
                      shippingModes.map((item) => (
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem
                          }}
                          value={item}
                          key={item}
                        >{item}</MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>

                <br/>
                <br/>
                <h3 className={classes.bodyText}>START LOCATION</h3>

                    <CustomInput
                      labelText="City or ZIP"
                      id="origin"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        type: "text",
                        onChange: (event) => this.handleChange(event)
                      }}
                    />
                    <FormControl
                    fullWidth
                    className={classes.selectFormControl}>
                    <InputLabel
                      htmlFor="originType"
                      className={classes.selectLabel}>
                      LOCATION TYPE:
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu
                      }}
                      classes={{
                        select: classes.select
                      }}
                      value={this.state.originType}
                      onChange={this.handleSelectChange}
                      inputProps={{
                        id: 'originType',
                        name: 'originType'
                      }}
                    >
                      {
                        locationTypes.map((item) => (
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem
                            }}
                            value={item}
                            key={item}
                          >{item}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                  <Datetime
                  selected={this.state.pickUpDate}
                  onChange={this.handlePickUpDateChange}
                  timeFormat={true}
                  isValidDate={this.valid}
                  renderInput={(dateInputProps, open, close) => (
                    <CustomInput
                      inputProps={{ ...dateInputProps, id: 'pickUpDate', name: 'pickUpDate', required: true, }}
                      onBlur={close}
                      onFocus={open}
                      labelText="Pickup Date"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  )}
                />

                  <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                  <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        tabIndex={-1}
                        onClick={() => this.handleTogglePickupServices('Lift Gate')}
                        checked={this.state.pickUpServices.indexOf('Lift Gate') !== -1 ? true : false}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        color="primary"
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot
                        }}
                      />
                    }
                    classes={{ label: classes.bodyText }}
                    label='Lift Gate at Pickup Point'
                  />
                </div>
                <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                <FormControlLabel
                  control={
                    <Checkbox
                      tabIndex={-1}
                      onClick={() => this.handleTogglePickupServices('Limited Access')}
                      checked={this.state.pickUpServices.indexOf('Limited Access') !== -1 ? true : false}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      color="primary"
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                      }}
                    />
                  }
                  classes={{ label: classes.bodyText }}
                  label='Limited Access Pick Up'
                />
              </div>

  

                    <CustomInput
                      labelText="Notes"
                      id="description"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        id: "pickUpNotes",
                        name: "pickUpNotes",
                        type: "text",
                        multiline: true,
                        rows: 5,
                        onChange: (event) => this.handleChange(event)
                      }}
                    />
                    <br />
                    <h3 className={classes.bodyText}>END LOCATION</h3>

                    <CustomInput
                      labelText="City or ZIP"
                      id="destination"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        type: "text",
                        onChange: (event) => this.handleChange(event)
                      }}
                    />
                    <FormControl
                    fullWidth
                    className={classes.selectFormControl}>
                    <InputLabel
                      htmlFor="destinationType"
                      className={classes.selectLabel}>
                      LOCATION TYPE:
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu
                      }}
                      classes={{
                        select: classes.select
                      }}
                      value={this.state.destinationType}
                      onChange={this.handleSelectChange}
                      inputProps={{
                        id: 'destinationType',
                        name: 'destinationType'
                      }}
                    >
                      {
                        locationTypes.map((item) => (
                          <MenuItem
                            classes={{
                              root: classes.selectMenuItem
                            }}
                            value={item}
                            key={item}
                          >{item}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                  <Datetime
                  selected={this.state.dropOffDate}
                  onChange={this.handleDropOffDateChange}
                  timeFormat={true}
                  isValidDate={this.valid}
                  renderInput={(dateInputProps, open, close) => (
                    <CustomInput
                      inputProps={{ ...dateInputProps, id: 'dropOffDate', name: 'dropOffDate', required: true, }}
                      onBlur={close}
                      onFocus={open}
                      labelText="Drop Off Date"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  )}
                />
                <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                <FormControlLabel
                  control={
                    <Checkbox
                      tabIndex={-1}
                      onClick={() => this.handleToggleDropOffServices('Lift Gate')}
                      checked={this.state.dropOffServices.indexOf('Lift Gate') !== -1 ? true : false}
                      checkedIcon={<Check className={classes.checkedIcon} />}
                      icon={<Check className={classes.uncheckedIcon} />}
                      color="primary"
                      classes={{
                        checked: classes.checked,
                        root: classes.checkRoot
                      }}
                    />
                  }
                  classes={{ label: classes.bodyText }}
                  label='Lift Gate at Pickup Point'
                />
              </div>
              <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
              <FormControlLabel
                control={
                  <Checkbox
                    tabIndex={-1}
                    onClick={() => this.handleToggleDropOffServices('Limited Access')}
                    checked={this.state.dropOffServices.indexOf('Limited Access') !== -1 ? true : false}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    color="primary"
                    classes={{
                      checked: classes.checked,
                      root: classes.checkRoot
                    }}
                  />
                }
                classes={{ label: classes.bodyText }}
                label='Limited Access Pick Up'
              />
            </div>

                    <CustomInput
                      labelText="Notes"
                      id="dropOffNotes"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        multiline: true,
                        rows: 5,
                        onChange: (event) => this.handleChange(event)
                      }}
                    />
                    <br />

                    <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                    <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          tabIndex={-1}
                          onClick={() => this.handleToggleServices('Hazmat')}
                          checked={this.state.services.indexOf('Hazmat') !== -1 ? true : false}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}
                          color="primary"
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                          }}
                        />
                      }
                      classes={{ label: classes.bodyText }}
                      label='Hazmat'
                    />
                  </div>
                  <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        tabIndex={-1}
                        onClick={() => this.handleToggleServices('Over Length')}
                        checked={this.state.services.indexOf('Over Length') !== -1 ? true : false}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        color="primary"
                        classes={{
                          checked: classes.checked,
                          root: classes.checkRoot
                        }}
                      />
                    }
                    classes={{ label: classes.bodyText }}
                    label='Over Length'
                  />
                </div>


                <h3 className={classes.bodyText}>ITEMS TO BE SHIPPED</h3>
                <FormControl
                fullWidth
                className={classes.selectFormControl}>
                <InputLabel
                  htmlFor="county"
                  className={classes.selectLabel}>
                  PACKAGING:
                </InputLabel>
                <Select
                  MenuProps={{
                    className: classes.selectMenu
                  }}
                  classes={{
                    select: classes.select
                  }}
                  value={this.state.county}
                  onChange={this.handleSelectChange}
                  inputProps={{
                    id: 'county',
                    name: 'county'
                  }}
                >
                  {
                    packagingTypes.map((item) => (
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem
                        }}
                        value={item}
                        key={item}
                      >{item}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>


                <CustomInput
                      labelText="Qty"
                      id="points"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        type: "number",
                        min: "0",
                        step: "1",
                        onChange: (event) => this.handleChange(event)
                      }}
                    />
                    <CustomInput
                    labelText="Total Weight"
                    id="points"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      required: true,
                      type: "number",
                      min: "0",
                      step: "1",
                      onChange: (event) => this.handleChange(event)
                    }}
                  />
                  <CustomInput
                  labelText="Heightt"
                  id="points"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    required: true,
                    type: "number",
                    min: "0",
                    step: "1",
                    onChange: (event) => this.handleChange(event)
                  }}
                />

                <CustomInput
                labelText="Width"
                id="points"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  required: true,
                  type: "number",
                  min: "0",
                  step: "1",
                  onChange: (event) => this.handleChange(event)
                }}
              />

              <CustomInput
              labelText="Depth"
              id="points"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                required: true,
                type: "number",
                min: "0",
                step: "1",
                onChange: (event) => this.handleChange(event)
              }}
            />

            <FormControl
            fullWidth
            className={classes.selectFormControl}>
            <InputLabel
              htmlFor="county"
              className={classes.selectLabel}>
              FREIGHT CLASS:
            </InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              value={this.state.county}
              onChange={this.handleSelectChange}
              inputProps={{
                id: 'county',
                name: 'county'
              }}
            >
              {
                freightClass.map((item) => (
                  <MenuItem
                    classes={{
                      root: classes.selectMenuItem
                    }}
                    value={item}
                    key={item}
                  >{item}</MenuItem>
                ))
              }
            </Select>
          </FormControl>

                  </GridItem>
                </GridContainer>
                {this.state.assigningAction ? (
                  <div>
                    <p className={classes.bodyText}>{this.state.assigningAction}</p>                   
                  </div>
                ) : (
                    <Button
                      type="submit"
                      color="primary"
                      style={{
                        marginLeft: "10px",
                        marginBottom: "10px"
                      }}
                    >
                      SUBMIT
              </Button>
                  )}
              </form>
            </div>

          )}
      </div>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Form);




// WEBPACK FOOTER //
// ./src/components/Forms/CreateOrderForm.jsx